import { createSlice } from '@reduxjs/toolkit';
import SimpleReactValidator from 'simple-react-validator';
import { QUOTING, QUOTED, ERROR } from 'shared/data/quoteSteps';

import defaultState from 'surface_mount_carriers/data/defaultState';
import { addToCart, doQuote } from 'surface_mount_carriers/store/thunks';
import { columnSelected, rowSelected } from 'surface_mount_carriers/data/parameters';

export const validator = new SimpleReactValidator();

const smcSlice = createSlice({
  name: 'smc',
  initialState: defaultState,
  reducers: {
    changeParameter(state, action) {
      const { name, value } = action.payload;
      state.parameters[name] = value;

      if (name === 'pressure_holder_type' && value === 'none') {
        state.parameters.pressure_holder_quantity = '';
      }

      state.parameters.row_selected = rowSelected(state.parameters);
      state.parameters.column_selected = columnSelected(state.parameters);
    },
    updateQuantity(state, action) {
      state.quantity = action.payload;
    },
    updateValidatorFlag(state) {
      state.validatorFlag = !state.validatorFlag;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(doQuote.pending, (state) => {
        state.quoteStep = QUOTING;
      })
      .addCase(doQuote.fulfilled, (state, action) => {
        const quote = action.payload;
        state.quoteStep = QUOTED;

        state.quote.line_items = quote.line_items;
        state.quote.number = quote.number;
        state.quote.variant_id = quote.variant_id;
        state.quote.product_name = quote.product_name;

        state.parameters.product_quote_number = quote.number;
      })
      .addCase(doQuote.rejected, (state) => {
        state.quoteStep = ERROR;
      })
      .addCase(addToCart.pending, (state) => {
        state.addingToCart = true;
      })
      .addCase(addToCart.rejected, (state) => {
        state.addingToCart = false;
      });
  },
});

export const {
  changeParameter,
  updateQuantity,
  updateValidatorFlag,
} = smcSlice.actions;

export default smcSlice.reducer;
